import { Input, ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'badge',
    templateUrl: './badge.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgeComponent {
    /**
     * Badge color
     */
    @Input()
    color = 'transparent';
}
